import React from "react";
import { Row, Col } from 'react-bootstrap';

import FeatureSectionItem from './featuresection-item';

function FeatureSectionItems(props) {
    const items = props.featureSectionItems;
    const itemsDetails = items.map(( item, index ) =>
        // Key should be specified inside the array.
        <Col key={ item.name.toString() } className="usr" lg={4} md={4} sm={6}>
            <FeatureSectionItem
                key={ item.name.toString() }
                value={ item }  
                index={ index }
                />
        </Col>
    );
    return (
        <Row className="ppl" id="about-anchor">
            { itemsDetails }
        </Row>
    );
}

export default class FeatureSectionRow extends React.Component {
    render() {
        return (
            <FeatureSectionItems featureSectionItems={ this.props.featureSectionItems }/>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/features/featuresection-row.jsx